import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import App from './App';
// 导入提供器组件
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist'; // 导入persistStore函数
// 导入 store
import store from './utils/redux/index.jsx'; // 导入创建的 Redux store
import { PersistGate } from 'redux-persist/integration/react';
import '@ant-design/v5-patch-for-react-19';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n'; // 你的 i18n 配置文件

import reportWebVitals from './reportWebVitals';
// 创建持久化存储对象
const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <React.StrictMode>
          <Router>
            <App />
          </Router>
        </React.StrictMode>
      </PersistGate>
    </Provider>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
